export default {
  "content": "<path d=\"M25.373 11.54L18.96 5.126 5.826 18.259a.654.654 0 00-.2.48l.707 4.76a.66.66 0 00.667.667l4.76.707a.626.626 0 00.467-.2L25.373 11.54zm3.947-3.947c.52-.52.52-1.36 0-1.88L24.786 1.18c-.52-.52-1.36-.52-1.88 0l-2.613 2.613 6.414 6.415 2.613-2.614z\"/><rect width=\"32\" height=\"5\" y=\"27.5\" rx=\"2.5\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "32",
    "height": "32",
    "fill": "#333",
    "viewBox": "0 0 32 32"
  }
};